import { IConfiguration } from './IConfiguration';
import { languagesConfiguration } from './LanguagesConfiguration';
const config: IConfiguration = {
   Environment : "prod",
   AriaIngestionKey: "36f18b389f2543c0b54bf5c5555e3587-e50b4ede-9173-4805-ab3a-7c8564e50b52-6674",
   AllowConsoleLogging: false,
   UrlEcs: 'https://a.config.skype.com/config/v1/skype/1.0.0.0/SkypeMeetNow?configOption=MEETNOW-SPA-PROD',
   UrlMeetingsApi: 'https://api.join.skype.com',
   IframeScrollbarHeightInPixels: 36,
   SilentLogin: {
      env: 'live',
      client_id: '971754',
      redirect_uri: 'https://api.join.skype.com',
  },
  Cookies: {
   skype: {
       name: 'SC',
       path: '/',
       maxAge: 3600 * 24 * 90, // 90 days
       domain: '.skype.com',
   },
   csrf: {
       name: 'x-csrf-token',
   },
   },
   ParentOrigin: "*",
   Languages: languagesConfiguration,
};

export default config;